<template>
  <div class="e-index">
    <div class="e-index-banner">
      <div class="e-index-bg">
        <p class="e-index-banner-title"><img src="../../../static/images/college_logo.png"/>睿慕课学院</p>
        <p class="e-index-banner-desc-large">人才成长摇篮，职业晋升起点</p>
        <p class="e-index-banner-desc-small">睿慕课学院是一个名副其实的学校，每个班级都有自己的班主任和助教，班级管理制度、测验评分体系健全，考试通过颁发毕业证书。从报名到毕业，为你全程服务。<br/>睿慕课学院是一个培养人才的摇篮，从课程规划到项目实践，都是最贴合工作需求的内容，全力帮助学员成为所在公司的核心技术人才。</p>
      </div>
    </div>
    <div class="e-index-recommend">
      <ul class="e-index-recommend-lessones">
        <li  class="e-index-recommend-lessones-lesson" v-for="(lesson, lessonIndex) in lessones" :key="lessonIndex">
          <router-link  v-if="lesson.mtype === '4'" :to="`/preview/${lesson.itemid}`">
              <p class="e-index-recommend-lessones-lesson-banner" :style="{backgroundImage: 'url(' + lesson.thumb + ')'}">{{lesson.title}}</p>
              <div class="e-index-recommend-lessones-lesson-info">
                <p class="e-index-recommend-lessones-lesson-info-info-desc">{{lesson.introduction}}</p>
                <ul class="e-index-recommend-lessones-lesson-info-info-companys">
                  <li class="e-index-recommend-lessones-lesson-info-info-company" v-for="(brand, brandIndex) in lesson.brand" :key="'brand-' + brandIndex">
                    <img :src="`http://docs-download.oss-cn-shanghai.aliyuncs.com/aiimooc_college/${brand}.png`" alt="">
                  </li>
                </ul>
                <router-link v-if="lesson.mtype === '4'" :to="`/preview/${lesson.itemid}`" class="e-index-recommend-lessones-lesson-info-info-join">了解详情</router-link>
                <a v-if="lesson.mtype === '5'" class="e-index-recommend-lessones-lesson-info-info-join" :href="lesson.underlink">了解详情</a>
              </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="e-index-desc">
      <p class="e-index-d-title">为什么选择睿慕课学院？</p>
      <div class="e-index-desc-content spe1">
        <div class="e-index-desc-info">
          <span class="e-index-desc-i"></span>
          <p class="e-index-desc-title">根据企业真实需求定制课程</p>
          <p class="e-index-desc-desc">根据企业的真实需求，为职场人士精心打造职场提升课。这些课程的讲师都是拥有丰富经验的技术实践者，通过自己的经验，言传身教，从最为重要的知识点切入，直接了当，旨在帮助学员将所学知识快速的进行转换，用于工作实践。</p>
        </div>
        <div class="e-index-desc-img">
          <img src="../../../static/images/index_2.png" alt="">
          <img src="../../../static/images/index_1.png" alt="">
        </div>
      </div>
      <div class="e-index-desc-content spe2">
        <div class="e-index-desc-img">
          <img src="../../../static/images/index_3.png" alt="">
          <img src="../../../static/images/index_4.png" alt="">
        </div>
        <div class="e-index-desc-info">
          <span class="e-index-desc-i"></span>
          <p class="e-index-desc-title">以项目实战内容为主培养人才</p>
          <p class="e-index-desc-desc">区别于常规课程，睿慕课学院更多的采用项目实战性的内容为主，贴近实践应用教学，每个阶段均有考核和总结，层层递进，直至学员彻底掌握所学的知识。在学习过程中，学员可以灵活安排时间，班主任会根据学员的反馈安排讲师答疑，在这样有监督和指导的学习环境中，学员可以快速成长。</p>
        </div>
      </div>
      <div class="e-index-desc-content spe3">
        <div class="e-index-desc-info">
          <span class="e-index-desc-i"></span>
          <p class="e-index-desc-title">贴心服务为您的职场提升铺路</p>
          <p class="e-index-desc-desc">提供一体化服务，班主任全程带班、“学-练-测-评“规划体系、1v1作业书面批改、直播答疑、辅助材料随时下载、精致纸质课件邮寄到家等服务，协助你顺利获取证书，在面试中加分，获得理想工作。</p>
        </div>
        <div class="e-index-desc-img">
          <img src="../../../static/images/index_5.png" alt="">
          <img src="../../../static/images/index_6.png" alt="">
        </div>
      </div>
    </div>
    <college-footer/>
  </div>
</template>

<script>
import api from '@/api/index'
import CollegeFooter from '@/components/footer/footer'

export default {
  data () {
    return {
      lessones: null
    }
  },
  async mounted () {
    let response
    response = await api.getLessonList()
    if (response.data) {
      this.lessones = response.data.data
    }
  },
  components: {
    CollegeFooter
  }
}
</script>

<style lang="scss">
a{
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}

.e-index{
  background-color: #fff;
  .e-index-banner{
    width: 100%;
    min-width: 1200px;
    height: 350px;
    text-align: center;
    color: white;
    background: transparent;
    box-sizing: border-box;
    background: url(../../../static/images/index_bg.png);
    .e-index-bg{
      padding-top: 74px;
      background: linear-gradient(to right, rgba($color: #52C9F4, $alpha: .6),rgba($color: #4440CF, $alpha: .6));
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
    .e-index-banner-title{
      line-height: 36px;
      font-size: 28px;
      margin-bottom: 20px;
      img{
        width: 24px;
        height: 35px;
        line-height: 36px;
        vertical-align: -7px;
        margin-right: 12px;
      }
    }
    .e-index-banner-desc-large{
      line-height: 55px;
      font-size: 46px;
      margin-bottom: 25px;
      font-weight: 700;
    }
    .e-index-banner-desc-small{
      line-height: 28px;
      font-size: 16px;
      font-weight: 100;
    }
  }
  .e-index-recommend{
    .e-index-recommend-lessones{
      width: 1200px;
      padding-top: 50px;
      padding-bottom: 100px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      flex-wrap: wrap;
      .e-index-recommend-lessones-lesson{
        width: 375px;
        box-sizing: border-box;
        height: 400px;
        overflow: hidden;
        margin-right: 37px;
        margin-bottom: 37px;
        &:nth-child(3n){
          margin-right: 0;
        }
        &:nth-last-child(1){
          margin-right: 0;
        }
        .e-index-recommend-lessones-lesson-banner{
          width: 100%;
          height: 185px;
          background-color: transparent;
          text-align: center;
          padding: 70px 60px 0px 60px;
          box-sizing: border-box;
          color: white;
          font-size: 20px;
          line-height: 30px;
          background-size: cover;
        }
        .e-index-recommend-lessones-lesson-info{
          padding-top: 25px;
          text-align: center;
          border: 1px solid #ECECEC;
          border-top: none;
          height: 215px;
          box-sizing: border-box;
          .e-index-recommend-lessones-lesson-info-info-desc{
            line-height: 24px;
            height: 48px;
            overflow: hidden;
            font-size: 15px;
            color: #7E7E7E;
            margin-bottom: 20px;
            padding: 0 30px;
          }
          .e-index-recommend-lessones-lesson-info-info-companys{
            height: 22px;
            margin-bottom: 25px;
            display: flex;
            justify-content: center;
            .e-index-recommend-lessones-lesson-info-info-company{
              background-color: transparent;
              height: 100%;
              margin-right: 5px;
              img{
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
              }
            }
          }
          .e-index-recommend-lessones-lesson-info-info-join{
            width: 200px;
            height: 45px;
            display: block;
            margin: 0 auto;
            color: white;
            font-size: 16px;
            line-height: 45px;
            background-color: #FF6565;
            text-decoration: none;
            border-radius: 3px;
            font-weight: 700;
            &:hover{
              background-color: #FE5454;
            }
          }
        }
      }
    }
  }
  .e-index-desc{
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 104px;
    .e-index-d-title{
      margin-bottom: 80px;
      line-height: 36px;
      font-size: 36px;
      color: #FE5454;
      text-align: center;
    }
    .e-index-desc-content{
      display: flex;
      justify-content: space-between;
      width: 100%;
      .e-index-desc-info{
        position: relative;
        .e-index-desc-title{
          font-size: 32px;
          line-height: 50px;
          margin-bottom: 28px;
          margin-top: 112px;
        }
        .e-index-desc-desc{
          line-height: 26px;
          font-size: 14px;
          max-width: 520px;
          color: #5C5F63;
        }
        .e-index-desc-i{
          position: absolute;
          top: 30px;
        }
      }
      &.spe1{
        margin-bottom: 188px;
        .e-index-desc-i{
          width: 54px;
          height: 54px;
          background: url(../../../static/images/index_i_1.png);
        }
        .e-index-desc-title{
          color: #3EB3F1;
        }
        .e-index-desc-img{
          width: 326px;
          position: relative;
          img{
            float: right;
            width: 318px;
            height: 192px;
            &:nth-child(2) {
              position: absolute;
              top: 165px;
              right: 163px;
              width: 326px;
              height: 208px;
            }
          }
        }
      }
      &.spe2{
        margin-bottom: 180px;
        .e-index-desc-i{
          width: 51px;
          height: 51px;
          background: url(../../../static/images/index_i_2.png);
          left: -68px;
          top: 55px;
        }
        .e-index-desc-title{
          color: #ECA923;
          margin-top: 58px;
        }
        .e-index-desc-desc{
          width: 469px;
        }
        .e-index-desc-img{
          width: 326px;
          position: relative;
          img{
            float: right;
            width: 309px;
            height: 147px;
            &:nth-child(2) {
              position: absolute;
              top: 121px;
              left: 164px;
              width: 330px;
              height: 211px;
            }
          }
        }
      }
      &.spe3{
        margin-bottom: 220px;
        .e-index-desc-i{
          width: 47px;
          height: 54px;
          top: 36px;
          background: url(../../../static/images/index_i_3.png);
        }
        .e-index-desc-title{
          color: #FC5959;
        }
        .e-index-desc-img{
          width: 326px;
          position: relative;
          img{
            float: right;
            width: 318px;
            height: 224px;
            &:nth-child(2) {
              position: absolute;
              top: 134px;
              right: 107px;
              width: 359px;
              height: 192px;
            }
          }
        }
      }
    }
  }
}
</style>
